import React, { useEffect } from "react";
import Swal from "sweetalert2";

import colors from "../../styles/colors/colors";
import { MessageType, ResponseMessages } from "../../constants/ResponseMessage";

interface SweetAlertProps {
  message1: string;
  message2: string;
  onClose?: () => void;
}

const SweetAlert: React.FC<SweetAlertProps> = ({
  message1,
  message2,
  onClose,
}) => {

  const showAlert = () => {
    const config = {
      title:
        message1 === ResponseMessages(MessageType.INGEST_SUCCESS) && "Success",
      icon:
        message1 === ResponseMessages(MessageType.INGEST_SUCCESS) && "success",
      type:
        message1 === ResponseMessages(MessageType.INGEST_SUCCESS) && "success",
      html: `${
        message1 === ResponseMessages(MessageType.INGEST_SUCCESS)
          ? `${message1}<br />${message2}<br />${ResponseMessages(
              MessageType.DOCUMENT_UPLOADED_SUCCESSFULLY
            )}`
        :
        message1 === ResponseMessages(MessageType.REFERRAL_NOT_CREATED)  ? `${message1}` :
        `<span id="swal-loader-msg">
        ${ResponseMessages(MessageType.DOCUMENT_UPLOAD_PROGRESS)}
        <span class="swal-dots">
        <span class="dot">.</span>
        <span class="dot">.</span>
        <span class="dot">.</span>
        </span>
      </span>
      <br />
      <br />
      <span>${ResponseMessages(MessageType.SWEET_ALERT_PROCESS_MESSAGE)}</span>
      <style>
        .swal-dots {
        display: inline-block;
        margin-left: 4px;
        }
        .swal-dots .dot {
        opacity: 0.2;
        animation: swal-dot-blink 1.4s infinite both;
        font-weight: bold;
        font-size: 1.2em;
        }
        .swal-dots .dot:nth-child(2) {
        animation-delay: 0.2s;
        }
        .swal-dots .dot:nth-child(3) {
        animation-delay: 0.4s;
        }
        @keyframes swal-dot-blink {
        0%, 80%, 100% { opacity: 0.2; }
        40% { opacity: 1; }
        }
      </style>`
      }
      `,
      showConfirmButton: false,
      didOpen: (popup: HTMLElement) => {
        popup.style.zIndex = "10";
      },
    } as import("sweetalert2").SweetAlertOptions;

    const configUpdate =
      message1 === ResponseMessages(MessageType.INGEST_SUCCESS)
      ? ({
        ...config,
        icon: "success",
        showConfirmButton: true,
        confirmButtonColor: colors.portalColor[13],
        customClass: {
          confirmButton:
          message1 === ResponseMessages(MessageType.INGEST_SUCCESS) &&
          "swal-confirm-btn",
          popup: "swal-popup-custom-zindex",
        },
        willClose: () => {
          if (onClose) onClose();
        },
        didOpen: (popup: HTMLElement) => {
          popup.style.zIndex = "10";
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        } as import("sweetalert2").SweetAlertOptions)
      : message1 === ResponseMessages(MessageType.REFERRAL_NOT_CREATED) ? ({
          ...config,
        html: `${message1}`,
        icon: "error",
        title: "Error",
        showConfirmButton: true,
        confirmButtonText: "Ok",
        confirmButtonColor: colors.portalColor[13],
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: {
          confirmButton: "swal-confirm-btn",
          popup: "swal-popup-custom-zindex",
        },
        willClose: () => {
          if (onClose) onClose();
        },
        didOpen: (popup: HTMLElement) => {
          popup.style.zIndex = "10";
        },
        } as import("sweetalert2").SweetAlertOptions)
          :         
          ({
        ...config,
        didOpen: (popup: HTMLElement) => {
          popup.style.zIndex = "10";
        },
        allowOutsideClick: false,
        allowEscapeKey: false,
        } as import("sweetalert2").SweetAlertOptions);
    Swal.fire(configUpdate);
  };

  useEffect(() => {
    showAlert();
  }, [message1, message2]);

  return null;
};

export default SweetAlert;
